
import { computed, defineComponent, ref } from "vue";
import CheckBox from "@/components/InputCheckbox.vue";
import InputSort from "@/components/InputSort.vue";
import AdminContractItem from "@/components/AdminContractItem.vue";
import AdminContractEdit, {
  EditMode,
} from "@/components/AdminContractEdit.vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router";
import store from "@/stores";
import { consts, ContractStatus, IContract } from "@/services/Models";
import { fromUnixTime, yyyyMMdd } from "@/lib/shared";

export default defineComponent({
  name: "AdminContract",
  components: {
    AdminContractItem,
    AdminContractEdit,
    CheckBox,
    InputSort,
  },
  setup() {
    const router = useRouter();
    const resource = store.useResource();
    const contracts = computed(() => resource.data.contracts);
    const toCreate = () =>
      router.push({
        name: routeNames.AdminContractCreate,
      });
      
    const istrialChecked = ref(true);
    const trialChecked = (checked: boolean) => {
      istrialChecked.value = checked;
    };
    const isAgreeChecked = ref(true);
    const agreeChecked = (checked: boolean) => {
      isAgreeChecked.value = checked;
    };
    const isValidityChecked = ref(true);
    const validityChecked = (checked: boolean) => {
      isValidityChecked.value = checked;
    };
    const isNearExpiredChecked = ref(true);
    const nearExpireChecked = (checked: boolean) => {
      isNearExpiredChecked.value = checked;
    };
    const isDisabledChecked = ref(true);
    const disabledChecked = (checked: boolean) => {
      isDisabledChecked.value = checked;
    };

    const isShowEdit = ref(false);
    const editMode = ref(EditMode.Edit);
    const editingModel = ref<IContract>();
    // 契約編集
    const toEdit = (m: IContract) => {
      editMode.value = EditMode.Edit;
      editingModel.value = m;
      isShowEdit.value = true;
    };
    // 契約停止
    const toStop = (m: IContract) => {
      editMode.value = EditMode.Stop;
      editingModel.value = m;
      isShowEdit.value = true;
    };
    // 契約削除
    const toDelete = (m: IContract) => {
      editMode.value = EditMode.Delete;
      editingModel.value = m;
      isShowEdit.value = true;
    };
    // 契約再開
    const toRestart = (m: IContract) => {
      editMode.value = EditMode.Restart;
      editingModel.value = m;
      isShowEdit.value = true;
    };
    // ユーザ一覧
    const toUsers = (m: IContract) => {
      if (m.id === undefined) return;
      router.push({
        name: routeNames.AdminContractUsers,
        params: { id: m.id },
      });
    };
    // 適用
    const apply = async (m: IContract) => {
      await resource.saveContract(m);
    };
    // 停止
    const remove = async (m: IContract) => {
      if (m.id === undefined) return;
      await resource.deleteContract(m.id);
    };

    const sortByAsc = (contracts: IContract[]) => {
      orderChenged(true);
      contracts.sort((a, b) => b.signed - a.signed);
    };
    const sortByDesc = (contracts: IContract[]) => {
      orderChenged(false);
      contracts.sort((a, b) => a.signed - b.signed);
    };
    
    const isOrderAsc = ref(true);
    const orderChenged = (isAsc: boolean) => {
      isOrderAsc.value = isAsc;
    }

    const isExpireDate = (expireDate: Date) => {
      const now = new Date();
      expireDate.setHours(0, 0, 0, 0);
      now.setHours(0, 0, 0, 0);
      return expireDate < now;
    };

    const isNearExpired = (expire: number) => {
      const oneMonthAgo = fromUnixTime(expire);
      oneMonthAgo.setDate(oneMonthAgo.getDate() - consts.expireOneMonth - 1);
      return isExpireDate(oneMonthAgo);
    };

    const filter = (contract: IContract) => {
      var isShowType = false;
      if(contract.type == 0) {
        isShowType = istrialChecked.value;
      }
      if(contract.type == 1) {
        isShowType = isAgreeChecked.value;
      }
      var isShowExpire = false;
      if(isNearExpired(contract.expire)) {
        isShowExpire = isNearExpiredChecked.value;
      } else {
        isShowExpire = isValidityChecked.value;
      }

      if(contract.status == ContractStatus.Disabled) {
        isShowExpire = isDisabledChecked.value;
      } 

      if(isOrderAsc.value) {
        sortByAsc(contracts.value);
      } else {
        sortByDesc(contracts.value);
      }

      return isShowType && isShowExpire;
    }

    sortByAsc(contracts.value);

    const isDefaultChecked = ref(true);
    return {
      contracts,
      toCreate,
      isShowEdit,
      editMode,
      editingModel,
      toUsers,
      toEdit,
      toStop,
      toRestart,
      toDelete,
      apply,
      remove,
      sortByAsc,
      sortByDesc,
      filter,
      istrialChecked,
      trialChecked,
      isAgreeChecked,
      agreeChecked,
      isValidityChecked,
      validityChecked,
      isNearExpiredChecked,
      nearExpireChecked,
      isDisabledChecked,
      disabledChecked,
      isNearExpired,
      isOrderAsc,
      orderChenged,
      isDefaultChecked,
    };
  },
});
